import type { PostSwitchGwbSubscriptionCadenceBodyRequest } from '../components/context/KeepSubscriptionsContext';
import env from '../config/env';
import type { ProductsSelfData } from '../interfaces/subscriptions';
import { get, post } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';

const getProductsSelfData = async (): Promise<ProductsSelfData> => {
  const url = apiPaths.getProductsSelfData;
  return get(env.REPLENISHMENT_API_URL, url).then(
    (response) => response.data,
  ) as Promise<ProductsSelfData>;
};

const postSwitchGwbSubscriptionsCadence = async (
  data: PostSwitchGwbSubscriptionCadenceBodyRequest,
): Promise<void> => {
  const url = apiPaths.postGwbExpirySwitchCadence;
  return post(env.REPLENISHMENT_API_URL, data, url).then(
    (response) => response.data,
  ) as Promise<void>;
};

export { getProductsSelfData, postSwitchGwbSubscriptionsCadence };
